import React from "react";

import { Table } from "@/components/flowbite/table/table";
import { TableBody } from "@/components/flowbite/table/table-body";
import { TableCell } from "@/components/flowbite/table/table-cell";
import { TableHead } from "@/components/flowbite/table/table-head";
import { TableHeader } from "@/components/flowbite/table/table-header";
import { TableRow } from "@/components/flowbite/table/table-row";
import Typography from "@/components/flowbite/typography/typography";
import { SquareIcon } from "@/components/icons-lib";
import { StudentCountsInShapeColorByEnum } from "@/providers/store/api/shapes/enums/student-counts-in-shape.enum";
import { formatNumber } from "@/shared/utils/format-number.util";

import { type SectionPlottedTableProps } from "./student-by.types";

const SectionSchoolPlottedTableComponent: React.FC<
  SectionPlottedTableProps
> = ({ data, type }) => {
  let title = "None";
  if (type === StudentCountsInShapeColorByEnum.SCHOOL) {
    title = "School";
  } else if (type === StudentCountsInShapeColorByEnum.GRADE) {
    title = "Grade";
  }
  return (
    <Table
      className="mt-2 w-full [&_td]:border-r-0 [&_th]:border-r-0"
      layout="fixed"
    >
      <TableHeader>
        <TableRow>
          <TableHead className="w-[170px] min-w-[170px] max-w-[170px] px-0">
            <Typography.TableTitleXS colorShade={300}>
              {title}
            </Typography.TableTitleXS>
          </TableHead>

          <TableHead className="w-[70px] min-w-[70px] max-w-[70px] p-0 text-right">
            <Typography.TableTitleXS colorShade={300}>
              # Plotted
            </Typography.TableTitleXS>
          </TableHead>

          <TableHead className="w-[75px] min-w-[75px] max-w-[75px] p-0 text-right">
            <Typography.TableTitleXS colorShade={300}>
              % Plotted
            </Typography.TableTitleXS>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody variant="unstyled">
        {data.map((item) => (
          <TableRow key={item.name}>
            <TableCell className="w-[165px] min-w-[165px] max-w-[165px] overflow-hidden px-0">
              <div
                className="flex min-w-0 items-center gap-2"
                title={item.name}
              >
                <SquareIcon
                  className="shrink-0"
                  color={item.color}
                  fill={item.color}
                  fillOpacity={0.4}
                  stroke={item.color}
                  variant="unstyled"
                />

                <Typography.BodyMRegular
                  className="min-w-0 flex-1 truncate"
                  colorShade={400}
                >
                  {item.name}
                </Typography.BodyMRegular>
              </div>
            </TableCell>

            <TableCell className="w-[75px] min-w-[75px] max-w-[75px] p-0 text-right">
              <Typography.BodyMRegular colorShade={400}>
                {formatNumber(item.plottedNumber)}
              </Typography.BodyMRegular>
            </TableCell>

            <TableCell className="w-[75px] min-w-[75px] max-w-[75px] p-0 text-right">
              <Typography.BodyMRegular colorShade={400}>
                {item.plottedPercentage.toFixed(2)}%
              </Typography.BodyMRegular>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SectionSchoolPlottedTableComponent;
